import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren, ChangeDetectorRef, HostListener, OnDestroy, ComponentFactoryResolver, Type, ViewContainerRef, ComponentRef, AfterViewInit, HostBinding } from '@angular/core';

import notify from 'devextreme/ui/notify';
import { NgxSpinnerService } from 'ngx-spinner';
import { AnagraficaService } from '../../services/anagrafica.service';
import { ComponentService } from '../../services/component.service';
import { costantValue, FormsTemplateService, GroupValidator, Validation } from '../../services/forms-template.service';

import { alert, confirm, custom } from 'devextreme/ui/dialog';

import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, ValidatorFn, FormControl, ValidationErrors } from '@angular/forms';
import { NicaDataGridComponent } from '../nica-data-grid/nica-data-grid.component';
import ODataStore from 'devextreme/data/odata/store';
import DataSource from 'devextreme/data/data_source';
import { of, Subject } from 'rxjs';
import { timeout, catchError, takeUntil } from 'rxjs/operators';
import { isArray } from 'rxjs/internal-compatibility';
import { Utenteservice } from '../../services/utente.service';
import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';

export type cmdType =
  'setData' |
  'disabled' |
  'enabled' |
  'setValidators' |
  'validationRules' |
  'cssClass' |
  'setLabel' |
  'visible' |
  'placeholder' |
  'readonly' |
  'setMinValue'

@Component({
  selector: 'app-new-nica-form',
  templateUrl: './new-nica-form.component.html',

  styleUrls: ['./nica-form.component.css'],
  /* host: {
    '(document:click)': 'onClickOutsideSearchBox($event)'
  }, */
})

export class NewNicaFormComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChildren('dynamicCustomComponentContainer', { read: ViewContainerRef }) dynamicCustomComponentContainer!: QueryList<ViewContainerRef> | undefined;
  dynamicCustomComponentMap = new Map<string, ComponentRef<any>[]>();
  dynamicCustomComponentName = new Map<string, string[]>();
  @ViewChildren(NicaDataGridComponent) dataGridForm?: QueryList<NicaDataGridComponent>;
  @Input() isPopUp: boolean = false;   // Se true la form è all'interno di un popUp
  @Input() remoteOperation: boolean = true;
  @Input() service: string;   // Richiama il service per costrure la form
  @Input() api: string;      // Chiamata api per ottenere i dati
  @Input() api_rest: boolean = false;      // Chiamata api-rest se true
  @Input() masterKey: string = 'id';      // 
  @Input() filterKey: string;   // url filter delle api (ES.Id IDSoggetto) 
  @Input() queryString: string;  // Query String (?nomecampo={{valore}})tabella come da istruzioni Swagger 
  @Input() filterStatic?: string = "TEST"; //Un filtro costante che non dovrebbe mai
  @Input() dataJson: any[];   // Passa il json con i dati anziche richimare l'api
  @Input() isEdit: boolean = false;
  @Input() type: any = 'simple'   // per visualizzare la form suddifica in tab è false di default tabbed || tabbedStep || simpleForm(per form semplice)
  @Input() nCol: any = 1
  @Input() labelWidth: number = 90
  @Input() heightForm: number //altezza form
  @Input() widthForm: number //larghezza form
  @Input() minColWidth: number;
  @Input() CustomButtonSetForm  // Bottoni Custom per eventi esterni 
  @Input() CustomButtonSetFormTop  // Bottoni Custom per eventi esterni 
  @Input() disableEditForm: boolean = false  // Abilita salvataggio del FORM da componente se TRUE di solalettura
  @Input() toolbarTop: boolean = false
  @Input() toolbarBottom: boolean = true
  @Input() ngClass: string;
  @Input() classe: string = '';
  @Input() remoteService: boolean = false
  @Input() isCheckChange: boolean = true;
  @Input() scrollingEnabled: boolean = true;
  @Input() footerDescTitle: string = '';
  @Input() parent;
  @Input() showNotifyAfterSave: boolean = true;
  @Input() nameSessionStorage: string = undefined;
  @Input() standardBtnBottom: any = [15, 16];
  //@Input() itemData: any;
  @Output() emittendButtonPush: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno gli eventi dei bottoni
  @Output() emittedItemsEvet: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno tutti gli eventi degli inèut
  @Output() emittedInitForm: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno dopo aver creato la form
  @Output() emittedDataSourceForm: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno dopo aver caricatato i data
  @Output() submitFormStep: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno del submit della form
  @Output() emittedDataGridEvent: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno del submit della form
  @Output() emittedAllEvent: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno del submit della form
  @Output() validationObj: EventEmitter<any> = new EventEmitter<any>();
  @HostBinding('class') hostClass = '';

  @Input() set class(value: string) {
    this.hostClass = value;
  }
  /**
   
   * 
   *  Campi già valorizzati dopo il caricamento del form, il caricamento è necessario per poter usufruire dell'
   *  evento 
  
  **/
  public static formDataBackupObject: any;
  $distruggi: Subject<void> = new Subject<void>()
  buttons: any[] = [];
  buttonsTop: any[] = [];
  hasCustomComponent: boolean = false
  innerTabs = {}
  addButtonStepOptions: any[];

  formTabselectedIndex: number = 0

  showButtonTrash: boolean[] = [false] //bootne pulisci campo
  cols: any = []; // colonne griglia dynamic 

  showDynamicContent: boolean; // proprietà per mostrare e nascondere popup dynamico 
  formActionType: string = 'insert' //Azione del Form se edit o insert
  formData: any = []; // che lo spiego a fare.
  formDataCopy: any = [];
  formDataService: any = []; // items che vengono dal serivice.

  dataSet: any = {}; // vedi doc DxForm
  selectedRows: any;
  dataSetCopy: any[] = []; // vedi doc DxForm
  allDataChanged: any[] = [];

  // Variabile che invio al componente nica-dynamic-content
  apiSource: any; // da inviare al componente dinamico
  componentType: any; // tipo di componente da mostrare nel popup default: grid e list, ma viene definito nel formTemplare service questo serve solo per passare dato al popup
  componentData: string = ''; // 
  titleDynamic: any; // titolo del popup 
  offsetY: any; // variabile per il posizionamento in verticale del popup
  offsetX: string;// variabile per il posizionamento in verticale orizzontale del popup
  height: string; // variabile altezza per popup 
  width: string; // variabile larghezza per popup 
  imageSources: any[] = [];

  itemOptions: any[] = []; //per costruire i campi speciali nella form dall'html

  //buttonOptionsSubmit: { text: string; type: string; useSubmitBehavior: boolean; };

  dataSourceLookUp: any[] = []; // DataSource del campo tipo lookup

  rowSelectLookUp: any[] = []

  dataSetDesc: any = []; // :campi speciali | <compare la descrizione se il campo da inviare via API per il salvaggio è di tipo ID>
  enableEditDynamicGrid: boolean;
  disabledDynamicElement: boolean[] = [];

  searchData: any = []; /** Di default è un array ma può essere un dataSource se necessario */
  searchDataShow: boolean = false;

  buttonToolbarState: boolean = true;
  validateFormGroupName: string;
  rowSelectedLookUp: any[] = [];
  lookUpValue: any[] = [];

  dataSedDynamicContent: any[] = []
  elementTarget: string;

  showDynamicPopOver: boolean;


  elementTargetAuocomplete: string;
  widthTargetAuocomplete: number;
  heightTargetAuocomplete: number;
  titleTargetAuocomplete: number;
  dataGroupItems: any[] = []
  dataGridItems: any[] = []
  timeInterval: any;
  store: any[] = [];
  costantValuesToDynamic: any;
  groupAutocomplete: boolean;
  comparisonTarget: any[] = [];
  compareValue: any;
  inputFormData: any[] = [];
  heightWrap: any;
  innerWidth: any;
  innerHeight: any;
  fullScreen: boolean = false;

  indexPositionList:
    {
      group: number,
      item: number
    } = { group: 0, item: 0 };

  tempDataFields: string[] = [];
  dataFields: any[] = [];
  loadingVisible = false;
  showForm: boolean = false
  formEdit
  dynamicForm: FormGroup;
  elementRef: any[] = []
  itemsCssClass: any[] = [];
  attributeItems: any[] = []
  tabIndexByDataField: {
    index: number;
    tabIndex: number;
    dataField: string;
    actived: boolean
  }[] = [];

  validationObject: any = {}
  validationClass: any = [];

  nColForm: any[] = []
  groupCssClass: any = [];
  groupItems: any = [];
  activeGroup: any = [];

  showToolbarBottomForm: boolean = false;
  timerCheck: number = 1000

  @HostListener('window:resize', ['$event'])
  @HostListener('keydown', ['$event'])

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault();

      // Ottieni il contenitore del form e l'elemento attualmente focalizzato
      const formD = document.getElementById(this.service) as HTMLElement;
      const focusedElement = document.activeElement as HTMLElement;
      let lastItemActived = this.tabIndexByDataField.filter(rep => rep.actived === true);
      if (formD.contains(focusedElement)) {
        let focusedFieldName = focusedElement.getAttribute('dataField') || focusedElement.getAttribute('id');

        if (!focusedFieldName) {
          focusedFieldName = lastItemActived[0]['dataField']
        }

        let currentIndex = this.tabIndexByDataField.findIndex(rep => rep.dataField === focusedFieldName);

        if (focusedFieldName && currentIndex >= 0) {
          let nextIndex = currentIndex;

          // Determina la direzione del tab in base al tasto Shift
          if (event.shiftKey) {
            // Se Shift è premuto, vai al tab precedente
            nextIndex--;

            // Trova il precedente elemento con tabIndex >= 0
            while (nextIndex >= 0 && this.tabIndexByDataField[nextIndex].tabIndex < 0) {
              nextIndex--;
            }

            // Se non c'è un elemento valido precedente, torna alla fine
            if (nextIndex < 0) {
              nextIndex = this.tabIndexByDataField.length - 1;
              while (nextIndex >= 0 && this.tabIndexByDataField[nextIndex].tabIndex < 0) {
                nextIndex--;
              }
            }
          } else {
            // Se Shift non è premuto, vai al tab successivo
            nextIndex++;

            // Trova il prossimo elemento con tabIndex >= 0
            while (nextIndex < this.tabIndexByDataField.length && this.tabIndexByDataField[nextIndex].tabIndex < 0) {
              nextIndex++;
            }

            // Se non c'è un prossimo elemento valido, torna all'inizio
            if (nextIndex >= this.tabIndexByDataField.length) {
              nextIndex = 0;
              while (nextIndex < this.tabIndexByDataField.length && this.tabIndexByDataField[nextIndex].tabIndex < 0) {
                nextIndex++;
              }
            }
          }

          if (nextIndex !== -1 && nextIndex < this.tabIndexByDataField.length) {
            const nextFieldName = this.tabIndexByDataField[nextIndex]['dataField'];
            const nextElement = document.querySelector(`[name="${nextFieldName}"]`) || document.querySelector(`[id="${nextFieldName}"]`);

            if (nextElement) {
              // Imposta il focus sul prossimo elemento
              (nextElement as HTMLElement).focus();

              // Aggiorna lo stato actived
              this.tabIndexByDataField[currentIndex]['actived'] = false;
              this.tabIndexByDataField[nextIndex]['actived'] = true;

              // Se l'elemento ha un metodo component.focusElement, chiamalo
              if (typeof this.elementRef[nextFieldName]['component'] !== 'undefined') {
                this.elementRef[nextFieldName]['component'].focusElement();
              }

              console.log('Elemento focalizzato:', nextFieldName);
            }
          }
        }
      }
    }
  }

  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  constructor(
    //private elementRef: ElementRef,
    private anagraficaService: AnagraficaService,
    private userComponentService: ComponentService,
    private loader: NgxSpinnerService,
    private formservice: FormsTemplateService,
    private formBuilder: FormBuilder,
    private cdRef: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private utenteService: Utenteservice
  ) {



    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;

    this.getEditor.bind(this)
    this.itemOption = this.itemOption.bind(this)
    this.validate = this.validate.bind(this)
    this.PulisciJson = this.PulisciJson.bind(this)

  }
  ngAfterViewInit(): void {
    /*  setTimeout(() => {
       this.renderForm();
     }, 200); */
    setTimeout(() => {
      this.renderForm();
    }, 200);

  }

  ngOnDestroy(): void {
    //if(this.nameSessionStorage>'')
    //sessionStorage.removeItem(this.nameSessionStorage);
    //console.log("Nica Form Distrutta")
    this.clearTuttiDynamicComponent()
    let emitEvent = {}
    emitEvent = {
      name: 'ngOnDestroy'
    }
    this.emittedItemsEvet.emit(emitEvent)
    this.emittedAllEvent.emit(emitEvent)
    this.$distruggi.next()
    this.$distruggi.complete()
  }

  screen(width) {
    return width < 1280 ? 'sm' : 'md';
  }


  ngOnInit() {
    //this.renderForm();
    // setTimeout(() => {
    //   this.renderForm();
    // }, 200);
  }


  async renderForm() {

    this.loader.show();



    if (!this.isEdit || this.disableEditForm) {

      await this.setData(this.dataJson);
    }

    if (this.remoteOperation && this.isEdit) {
      await this.getData();
    }

    await this.renderToolBar();


    if (this.showForm) {
      setTimeout(async () => {
        this.formLoaded();
        this.loader.hide()
      }, 300);
      //await this.formLoaded();

      // this.loader.hide()

    }


  }


  restructureFormDataService() {
    this.formDataService = this.formDataService.filter(r => r.itemType == 'group' || r.itemType == 'formTabbed');
    //console.log(this.formDataService)
    this.formDataService.forEach((resGroup, i) => {
      if (resGroup.itemType == 'formTabbed') {
        this.innerTabs[i] = {
          visible: true,
          id: resGroup.groupDataField
        }
      }
      resGroup.data.forEach(dataR => {
        //console.log('dataField---->',dataR.dataField)
        if (typeof dataR.editorType == 'undefined') {
          dataR.editorType = 'textBox'
        }

        if (!dataR.editorType) {
          dataR.editorType = 'textBox'
        }
        if (dataR.dynamic) {
          if (dataR.dynamic.valueExpr != '' && dataR.dynamic.displayExpr != '') {

            const hiddendataR = { ...dataR };

            hiddendataR.hideOnEdit = true;
            delete hiddendataR.dynamic;
            hiddendataR.type = 'campoHidden';
            hiddendataR.isClonato = true;
            hiddendataR.editorType = 'hiddenBox';
            hiddendataR.colSpan = resGroup.colCount;

            let fDataField = dataR.dataField[0].toUpperCase() + dataR.dataField.slice(1);
            let newDataField = dataR.dynamic.displayExpr + '_' + fDataField;

            hiddendataR.correlateDataField = newDataField;
            resGroup.data.push(hiddendataR);
            //console.log('dopo--->' + hiddendataR.dataField, resGroup.data)



            dataR.dataField = newDataField;
            //dataR.concatDataField = hiddendataR.dataField
            if (dataR.dynamic.related) {
              //Se object usa tutto il l'oggetto
              let compoRel = dataR.dynamic.valueExpr + '|' + hiddendataR.dataField
              dataR.dynamic.related.push(compoRel)
            } else {
              let compoRel = dataR.dynamic.valueExpr + '|' + hiddendataR.dataField
              dataR.dynamic.related = [compoRel]
            }

            dataR.dynamic.valueExpr = ''

          }
        }
        if (dataR.type === 'customComponent' && dataR.component) {
          //console.log(dataR)
          this.hasCustomComponent = true
          const tipoDynamic = dataR.dataType !== undefined ? dataR.dataType : 'inline'
          if (this.dynamicCustomComponentContainer) {
            if (tipoDynamic === 'inline') {
              const dataToSend = this.processaDataToSendDynamic(dataR.component.configuration)
              setTimeout(() => {
                this.aggiungiDynamicComponent(dataR.dataField, dataR.component.nameComponent, dataR.component.name, dataToSend);
              }, 500)
            }
          }
        }
      })
    })
  }

  async buildFormEditors() {

    if (this.remoteService) {
      //this.getServiceFromApi(this.service);

    } else {

      if (typeof this.formservice.getService(this.service) == 'undefined') {
        alert('Template' + this.service + ' non esiste', 'Errore!')
        return
      }
      this.formDataService = JSON.parse(JSON.stringify(this.formservice.getService(this.service)));
      this.restructureFormDataService()
    }


    /*  this.dynamicForm = this.formBuilder.group({
       Rows: this.formBuilder.array([])
     }); */


    ////////console.log(JSON.stringify(this.formDataService))
    if (this.formDataService && !this.remoteService) {

      let formData = [];

      formData = this.formDataService


      let newData: any[] = [];
      let formGroupFields = {}
      let formGroup = {};
      let grData = null
      let tabIndex = 0;

      formData.forEach((gruppo, index) => {




        let colCount = parseInt(gruppo.colCount);
        let contatore = 0;
        let rigaNumero = 1;



        gruppo.rowGroup = [];


        if (typeof gruppo.groupDataField != 'undefined') {
          if (grData != gruppo.groupDataField) {
            formGroupFields = {}
          }
          // formGroupFields = {}
          grData = gruppo.groupDataField;



        } else {
          grData = 'Rows_' + index
          gruppo.groupDataField = grData;
          formGroupFields = {}
        }

        this.groupCssClass[grData] = [];
        this.groupItems.push({

          caption: gruppo.caption,
          groupName: grData
        })

        if (index == 0) {
          this.activeGroup[index] = true;
        } else {
          this.activeGroup[index] = false;
        }


        if (gruppo.class) {
          this.groupCssClass[grData].push(gruppo.class)
        }

        if (gruppo.colSpan == this.nCol) {
          this.nColForm[grData] = 10;
          gruppo.colGroup = 'auto'
        } else {
          this.nColForm[grData] = this.nCol
        }


        this.attributeItems = [];

        if (gruppo.data.length == 0) {
          return
        }

        if (typeof gruppo.data == 'undefined') {
          console.error("è presente un errore nella struttura del file service")
          return
        }


        gruppo.data.forEach(dataR => {

          if (typeof dataR.visible != 'undefined') {
            if (!dataR.visible) {
              return
            }

          }


          let validators = [];
          this.validationClass[dataR.dataField] = false;

          if (typeof dataR.validation != 'undefined') {
            validators = this.addValidator(dataR.validation, dataR.dataField);
            // validators = dataR.validation[0].type == 'required' ? Validators.required : null;
            // this.validationObject = {
            //   ...this.validationObject,
            //   [dataR.dataField]: {
            //     type: dataR.validation[0].type,
            //     message: dataR.validation[0].message
            //   }

            // }

          }

          let itemValue = dataR.dataType == 'boolean' ? false : null
          if (typeof this.dataSet[dataR.dataField] != 'undefined') {
            itemValue = this.dataSet[dataR.dataField]
          }


          if (dataR.dataField && dataR.type != 'empty' && dataR.type != 'campoComponent' && dataR.type != 'customComponent') {
            formGroupFields[dataR.dataField] = [{ value: itemValue, disabled: false }, validators];
            //console.log(formGroupFields)
            if (dataR.type != 'campoHidden') {
              if (!dataR.disabled) {
                tabIndex++
              } else {
                tabIndex = -1
              }




              this.tabIndexByDataField.push({
                index: tabIndex,
                tabIndex: tabIndex,
                dataField: dataR.dataField,
                actived: false
              })
            }
          }

          this.dataSet[dataR.dataField] = itemValue //Pezzottone dei mie...dovuta a select con devExtreme
          //grData = this.dynamicForm.get(gruppo.groupDataField)
          formGroup[grData] = this.formBuilder.group(formGroupFields);

          if (typeof dataR.labelVisible == 'undefined') {
            dataR.labelVisible = true
          }

          if (dataR.type == 'campoGriglia') {
            this.dataGridItems[dataR.dataField] = dataR
          }

          if (dataR.type == 'empty' && dataR.caption) {
            dataR.type = 'divider';
            dataR.nCol = 10

          }

          if (!dataR.nCol && typeof dataR.colSpan == 'undefined') {
            dataR.nCol = 'auto'
          } else if (typeof dataR.colSpan != 'undefined' && typeof dataR.nCol != 'undefined') {
            dataR.nCol = dataR.nCol

          } else if (dataR.colSpan && !dataR.nCol) {
            dataR.nCol = 'auto'
          }


          this.itemsCssClass[dataR.dataField] = []
          if (dataR.class) {
            this.itemsCssClass[dataR.dataField].push(dataR.class)
          }

          if (dataR.labelPosition) {
            console.log('Label Position', dataR.labelPosition);
            this.itemsCssClass[dataR.dataField].push('labelPositionTop');
          }

          if (!dataR.colSpan) {
            dataR.colSpan = 1;
          }
          if (dataR.width) {

            let larghezzaFinestraIniziale = 100 //dataR.width = null ;
            let width
            let dataRwidth = dataR.width.toString()
            if (dataRwidth.includes('vw')) {
              /*width = dataR.width.replace('vw', '')
              width = (width / 100) * 100;*/
              width = ''
            } else if (dataRwidth.includes('px')) {
              width = dataR.width.replace('px', '')

              width = (width / larghezzaFinestraIniziale) * 100;
            } else {
              width = dataR.width
            }


            dataR.width = width
          }

          if (parseInt(dataR.colSpan) == colCount) {
            newData.push(dataR);
            contatore = colCount
          }

          if (contatore < colCount) {
            newData.push(dataR)
            contatore++
          }
          if (dataR.dataField) {
            this.formDataCopy.push(dataR);

          }


          if (contatore == colCount) {
            gruppo.rowGroup[rigaNumero] = newData;
            newData = [];
            contatore = 0;
            rigaNumero++
          }


        })

        let groupLevelRules: any[] = gruppo.groupValidation || [];
        const groupValidators = groupLevelRules.length > 0 ? [this.buildDynamicGroupValidator(groupLevelRules)] : [];
        formGroup[grData] = this.formBuilder.group(formGroupFields, {
          validators: groupValidators
        });
      })

      this.validationObj.emit(this.validationObject)
      //thttps://stackblitz.com/edit/angular-8-reactive-form-ysv8vj?file=src%2Fapp%2Fapp.component.ts
      //https://stackblitz.com/edit/angular-8-dynamic-reactive-forms-example-hk921x?file=app%2Fapp.component.ts%3AL26,app%2Fapp.module.ts

      this.dynamicForm = this.formBuilder.group(formGroup);
      this.validationObj.emit(this.dynamicForm)

      this.showForm = true
      this.loader.hide();



    } else {

      this.loader.hide();
      alert("E' stato rilavato un problema  nel chiamare il service: " + this.service, 'Attenzione');
    }


  }

  buildDynamicGroupValidator(rules: GroupValidator[]): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      let hasGroupError = false;
      rules.forEach(rule => {
        const sourceDataField = group.get(rule.sourceDataField);
        const targetDataField = group.get(rule.targetDataField);
        if (!sourceDataField || !targetDataField) return;
        this.validationObject = {
          ...this.validationObject,
          [rule.targetDataField]: []
        }
        this.validationObject[rule.targetDataField].push({
          type: rule.keyError,
          message: rule.message
        })
        const valA = sourceDataField.value;
        const valB = targetDataField.value;
        let valid = true;
        switch (rule.operator) {
          case '=':
            valid = valA === valB;
            break;
          case '!=':
            valid = valA !== valB;
            break;
          case '>':
            valid = valA > valB;
            break;
          case '<':
            valid = valA < valB;
            break;
          case '<=':
            valid = valA <= valB;
            break;
          case '>=':
            valid = valA >= valB;
            break;
          default:
            return
        }
        const errors = targetDataField.errors || {};
        if (!valid) {
          hasGroupError = true;
          errors[rule.keyError] = true;
          targetDataField.setErrors(errors);
        } else {
          delete errors[rule.keyError];
          targetDataField.setErrors(Object.keys(errors).length ? errors : null);
        }
      });
      return hasGroupError ? { dynamicGroupInvalid: true } : null;
    };
  }

  addValidator(validationArr: Validation[], dataField) {
    this.validationObject = {
      ...this.validationObject,
      [dataField]: []
    }
    return validationArr.map((obj) => {
      this.validationObject[dataField].push({
        type: obj.type,
        message: obj.message
      })

      switch (obj.type) {
        case 'required':
          this.validationClass[dataField] = false; //era true
          return Validators.required;
        case 'min':
          return Validators.min(Number(obj.value));
        case 'max':
          return Validators.max(Number(obj.value));
        case 'minLength':
          return Validators.minLength(Number(obj.value));
        case 'maxLength':
          return Validators.maxLength(Number(obj.value));
        case 'pattern':
          return Validators.pattern(obj.value.toString());
        default:
          return null;
      }
    }).filter(v => v !== null);
  }
  validationObjEntry(event: FormGroup) {
    if (!(event instanceof FormGroup)) {
      Object.assign(this.validationObject, event)
      return
    }
    // Clono tutto il form figlio
    const clonedChild = this.cloneControl(event) as FormGroup;
    if (typeof clonedChild === undefined) {
      return
    }
    // Se voglio "fondere" i singoli controlli/cloni nel padre, faccio:
    const mergedControls: { [key: string]: AbstractControl } = {
      ...this.dynamicForm.controls  // Mantengo i controlli già esistenti nel padre
    };

    // Aggiungo i controlli del figlio clonato
    Object.keys(clonedChild.controls).forEach(childKey => {
      const childControl = clonedChild.get(childKey);
      // se è un Group, potrei iterare i suoi controlli, oppure lo aggiungo come group
      // DIPENDE DALLA STRUTTURA DESIDERATA
      mergedControls[childKey] = childControl!;
    });

    // Ricreo o aggiorno il formGroup del padre
    this.dynamicForm = new FormGroup(mergedControls);
  }

  cloneControl(control: AbstractControl): AbstractControl {
    if (control instanceof FormControl) {
      return new FormControl(
        control.value,
        control.validator,
        control.asyncValidator
      );
    } else if (control instanceof FormGroup) {
      const group: { [key: string]: AbstractControl } = {};
      Object.keys(control.controls).forEach((k) => {
        group[k] = this.cloneControl(control.controls[k]);
      });
      return new FormGroup(group, control.validator, control.asyncValidator);
    } else if (control instanceof FormArray) {
      const arr = control.controls.map(c => this.cloneControl(c));
      return new FormArray(arr, control.validator, control.asyncValidator);
    } else {
      return undefined
    }
  }

  setDataOfCorrelatedItems(dataField) {

    if (typeof this.elementRef[dataField] != 'undefined') {
      if (typeof this.elementRef[dataField].campo != 'undefined') {

        let campotype = this.elementRef[dataField].campo.type
        if (campotype == 'campoHidden') {
          let correlateDataField = this.elementRef[dataField].campo.correlateDataField

          if (!correlateDataField) {
            return
          }

          if (typeof this.elementRef[correlateDataField].campo.dynamic != 'undefined') {
            let value = this.dataSet[dataField];
            if (value) {
              const cDataField = this.elementRef[correlateDataField].campo
              this.getElementValue(cDataField, value)

            }
          }
        }
      }
    }

  }

  getFormGroup(group) {

    return this.dynamicForm.get(group)


  }

  getTabIndex(dataField) {
    let indexArray = this.tabIndexByDataField.findIndex(res => res.dataField == dataField)

    try {
      if (typeof this.tabIndexByDataField[indexArray] == "undefined") {
        return -1
      }
      return this.tabIndexByDataField[indexArray]['tabIndex']
    } catch (error) {
      console.log(dataField, error)
    }


  }


  setActiveGroup(groupIndex) {



    this.activeGroup = [false]


    this.activeGroup[groupIndex] = true

    //return groupData.active
  }

  async getData() {

    if (!this.isEdit) {
      this.formActionType = 'insert'

      return

    }

    var EndPoint = ''

    let subject = await this.anagraficaService.getValue(this.api, this.filterKey, this.queryString, this.api_rest)

    if (subject['items']) {
      subject = subject['items'];
    } else if (subject['data']) {
      if (isArray(subject['data']))
        subject = subject['data'][0];
      else subject = subject['data'];
    } else {
      subject = subject;

    }
    let event = {
      name: 'formDataInit',
      formData: subject,
      masterComponet: (this.formEdit) ? this.formEdit : undefined
    }
    this.emittendButtonPush.emit(event);
    this.emittedAllEvent.emit(event)
    this.emittedDataSourceForm.emit(event)

    await this.setData(subject);
    this.formActionType = 'edit'


  }

  async setData(dataJson) {

    if (dataJson) {

      this.dataSet = dataJson
      this.dataSetCopy = dataJson;
      this.loadingVisible = false;





    }
    await this.buildFormEditors()
  }

  getElementValue(cDataField, val) {
    if (val) {
      let rel = ''


      let queryString

      if (typeof val == 'object' && !Array.isArray(val)) {
        let displayExpr = cDataField.dynamic.displayExpr
        this.dataSet[cDataField.dataField] = val.map(ree => {
          if (typeof ree === 'string' || typeof ree === 'number' || typeof ree === 'boolean') {
            return ree; // Se ree è una stringa, restituisci la stringa stessa
          } else if (typeof ree === 'object' && typeof ree[displayExpr] !== 'undefined') {
            return ree[displayExpr]; // Se ree è un oggetto con displayExpr definito, restituisci displayExpr
          }
        })
        return
      }

      if (cDataField.dynamic.queryString) {
        if (cDataField.dynamic.queryString.includes('$')) {
          let arrQuerySTemp = cDataField.dynamic.queryString.split('$');

          let query = arrQuerySTemp[0];
          let filter = ''
          const dataSet = arrQuerySTemp[1].split('&')[0];
          if (dataSet == cDataField.dataField) {
            filter = val;
            val = '';
          } else {
            if (typeof this.dataSet[dataSet] != 'undefined') {

              filter = this.dataSet[dataSet];
            }
          }



          if (typeof filter != 'undefined') {
            queryString = query + filter
          }

        } else {
          queryString = cDataField.dynamic.queryString
        }
      }
      if (typeof val != 'object' && !Array.isArray(val)) {
        let api_rest = cDataField.dynamic.settingGrid.wingap === undefined ? this.api_rest : !cDataField.dynamic.settingGrid.wingap
        this.anagraficaService.getValue(cDataField.dynamic.dataSource, val, queryString, api_rest).then(res => {

          if (res['items']) {
            res = res['items']
          } else if (res['data']) {
            res = res['data']
          }

          let displayExpr = cDataField.dynamic.displayExpr
          this.dataSet[cDataField.dataField] = res[displayExpr]

          //? ----- SIMONE = per popolare un campo related di sola visualizzazioen in base al dynamic 
          cDataField.dynamic.related.map((campo: string, index, array) => {
            let campoSplit = campo.split('|')
            if (this.dataSet[campoSplit[1]] === undefined || this.dataSet[campoSplit[1]] === null) {
              this.dataSet[campoSplit[1]] = res[campoSplit[0]]
            }
          })

        })
      }



    }
  }

  outputElementInit(e) {

    let id = e.htmlElement.id
    if (id) {
      //console.log('outputElementInit ',e)
      this.elementRef[id] = e;

      this.attributeItems[id] = {
        label: {},
        visible: true,
        disabled: false,

      }
      if (e.value !== undefined && e.value !== null) {
        this.dataSet[id] = e.value
      }
    }
    this.setDataOfCorrelatedItems(id);
    if (e.campo && e.campo.switchBox) {
      this.dataSet[id] = e.campo.switchBox.defaultValue

    }
    this.cdRef.detectChanges()
    this.emittedItemsEvet.emit(e)
  }

  outputElementFocus(event) {
    const name = event.name
    switch (name) {
      case 'focusOut':
        let curActiveIdex = this.tabIndexByDataField.findIndex(res => res.dataField == event.dataField)
        this.tabIndexByDataField[curActiveIdex]['actived'] = false
        break;

      default:
        break;
    }
  }

  renderToolBar() {

    if (this.disableEditForm) {
      this.standardBtnBottom = [];

    }

    if (this.CustomButtonSetForm) {

      const buttonsToAdd = this.CustomButtonSetForm;
      buttonsToAdd.forEach((button, i) => {
        let id = 'custom_' + i
        if (typeof button.event != 'undefined') {
          id = button.event
        } else {
          id = button.id
        }
        this.buttons.push({
          location: button.location,
          widget: button.widget,
          locateInMenu: button.locateInMenu,
          stylingMode: button.stylingMode,
          text: button.text,
          icon: button.icon,
          hint: button.hint,
          visible: true,
          disabled: button.disabled,
          id: id

        })
      })

    }

    if (this.toolbarBottom) {
      this.showToolbarBottomForm = true
    }


    if (this.CustomButtonSetFormTop) {
      const buttonsToAddT = this.CustomButtonSetFormTop;
      buttonsToAddT.forEach(button => {
        this.buttonsTop.push({

          location: button.location,
          widget: button.widget,
          locateInMenu: button.locateInMenu,

          options:
          {
            stylingMode: button.stylingMode,
            text: button.text,
            icon: button.icon,
            hint: button.hint,
            visible: button.visible,
            disabled: button.disabled,
            onClick: ($event) => {
              let event = {
                buttonEvent: $event,
                event: button.event,
                accesskey: button.accessKey,
                button: button,
                data: this.formData,
                name: button.name
              }
              this.emittendButtonPush.emit(event)
              this.emittedAllEvent.emit(event)

            },
          }

        })
      })

    }


  }

  async toolbarBottomEmitted(ev) {
    switch (ev) {
      case 15:
      case 22:
        await this.beforeSave()
        break;
      case 16:
      case 23:
        await this.checkReturn()
        break;
      default:
        let Event
        if (typeof ev == 'string') {

          Event = {
            name: ev
          }
          this.emittendButtonPush.emit(Event);
          /* this.emittedAllEvent.emit(Event) */
          return
        }
        this.emittendButtonPush.emit(ev);
        /* this.emittedAllEvent.emit(ev) */
        break;
    }
  }

  emitButtonDynamic(event) {

    let form = this;
    let dataEditForm = this.dataSet;

    if (event.name == 'beforeEmitButtonDynamic') {

      let ev = {
        name: 'beforeMitter',
        formData: dataEditForm,
        masterComponent: form,
        campo: event,
        cancel: false
      }

      this.emittedItemsEvet.emit(ev)
      this.emittedAllEvent.emit(ev)

      if (ev.cancel) {
        //ho fatto un po di inciarmi ma mi scoccio di sistemare xke sono scazzato.
        event.cancel = true;
        return ev
      }

    }

    switch (event.name) {

      case 'buttonDynamicOpenComponent':
        this.openComponent(event.component, event.campo)
        break;
      case 'emitButtonType2':

        let emitted = {
          buttonEvent: event,
          event: event.button.event,
          accesskey: event.button.accessKey,
          campo: event.campo,
          data: this.dataSet,
          name: event.button.name,
          component: this
        }
        this.emittendButtonPush.emit(emitted);
        //this.emittedAllEvent.emit(emitted)
        break;


      default:
        break;
    }

  }

  outputElementValue(ev) {




    const name = ev.name;
    const dataSet = { ...this.dataSet };

    let emitEvent = {}
    let component;
    if (ev.component) {
      component = ev.component
    } else if (ev.element) {
      component = ev.element
    }
    switch (name) {
      case "selectChange":

        this.allDataChanged[ev.campo.dataField] = ev.value

        let cascading = ev.campo.lista.cascading;
        if (typeof cascading != 'undefined') {

          cascading.forEach(resC => {
            let casc = resC.split('|');
            //this.formRefreshInputData(casc[1],null)
            let editorComponent = this.elementRef[casc[1]].component;
            //this.dataSet[casc[1]] = null;
            editorComponent.getDataSource()
          })
        }
        if (typeof this.nameSessionStorage != 'undefined') {
          delete this.dataSet[""];
          sessionStorage.setItem(this.nameSessionStorage, JSON.stringify(this.dataSet))
        }
        emitEvent = {
          campo: ev.campo,
          component: component,
          dataFields: ev.dataField,
          event: ev,
          formData: dataSet,
          masterComponent: this,
          name: 'selectedItemLista',
          value: ev.value,
          valore: ev.value,
          displayValue: ev.displayVlaue,
          selectedElement: ev.selectedElement
        }
        this.emittedItemsEvet.emit(emitEvent)
        this.emittedAllEvent.emit(emitEvent)
        this.validationObj.emit(this.dynamicForm)
        break;

      case "onValueChanged":

        this.allDataChanged[ev.campo.dataField] = ev.value;
        //? Serve per aggiornare il campo displayExpr correlato al campo related del campo aggiornato 
        if (ev.previousValue !== undefined) {
          if (this.elementRef[ev.campo.correlateDataField] && this.elementRef[ev.campo.correlateDataField].campo) {
            const cDataField = this.elementRef[ev.campo.correlateDataField].campo
            this.getElementValue(cDataField, ev.value)
          }
        }
        if (typeof this.nameSessionStorage != 'undefined') {
          delete this.dataSet[""];
          sessionStorage.setItem(this.nameSessionStorage, JSON.stringify(dataSet))
        }
        emitEvent = {

          value: ev.value,
          campo: ev.campo,
          formData: dataSet,
          component: component,
          masterComponent: this,
          name: 'onValueChanged',
        }

        this.emittedItemsEvet.emit(emitEvent)
        this.emittedAllEvent.emit(emitEvent)
        this.validationObj.emit(this.dynamicForm)
        break;
      case "onValueChangedAfterGridSelect":
        this.allDataChanged[ev.campo.dataField] = ev.value

        emitEvent = {

          value: ev.value,
          previousValue: ev.previousValue,
          campo: ev.campo,
          formData: dataSet,
          component: ev.input,
          masterComponent: this,
          name: 'onValueChanged'

        }

        this.emittedItemsEvet.emit(emitEvent)
        this.emittedAllEvent.emit(emitEvent)
        this.validationObj.emit(this.dynamicForm)
        break;
    }

  }

  outputDataGridEvent(ev) {
    this.emittedDataGridEvent.emit(ev)
    this.emittedAllEvent.emit(ev)

  }

  async formLoaded() {

    if (this.dynamicForm) {

      if (this.nameSessionStorage > '') {
        if (sessionStorage.getItem(this.nameSessionStorage)) {
          this.dataSet = JSON.parse(sessionStorage.getItem(this.nameSessionStorage))
        }
      }

      let dataToSend = {
        formData: this.dataSet,
        component: this,
        form: this.dynamicForm,
        name: 'formContentInitializzed',
      }
      this.emittedInitForm.emit(dataToSend);
      this.emittedAllEvent.emit(dataToSend)
      this.loader.hide();
      if (this.nameSessionStorage == 'NnFarla') {
        if (sessionStorage.getItem(this.nameSessionStorage)) {
          this.dataSet = JSON.parse(sessionStorage.getItem(this.nameSessionStorage))
          setTimeout(() => {
            this.formRefreshGridDataSource()
          }, 800);

        }
      }

      /***Attiva il focus sul primo field della form***/

      try {
        /* this.tabIndexByDataField[0]['actived'] = true;
        let dataField = this.tabIndexByDataField[0]['dataField']
        if(typeof this.elementRef[dataField].component != 'undefined'){
          this.elementRef[dataField].component.focusElement();
        } */
      } catch (error) {

      }
    }

  }


  /** Modifica degli elementi della form **/


  public itemOption(path, command?: cmdType, value?) {


    let name = ''
    const control: AbstractControl | null = this.dynamicForm.get(path);


    if (control) {

      name = this.getFormGroupName(control);

      switch (command) {
        case 'setData':        //!NON FUNZIONa
          const ref = this.elementRef[name]
          if (ref && ref.component && ref.component.optionData) ref.component.optionData = value
          break;
        case 'disabled':
          if (value === true) {
            if (name) {
              this.itemsCssClass[name].push('nica-disabled');
              let index = this.tabIndexByDataField.findIndex(r => r.dataField == name)
              this.tabIndexByDataField[index]['tabIndex'] = -1;
              // carmine ho aggiunto questo if in quanto elemenRef di qualche campo era UNDEFINED
              if (this.elementRef[name])
                this.elementRef[name].editorComponent.isDisabled = false
              control.disable();
            }
          }
          if (value === false) {
            if (name) {
              let index = this.itemsCssClass[name].findIndex(r => r == 'nica-disabled')
              //console.log('itms-->' + name, this.itemsCssClass[name])
              if (index >= 0) {

                this.itemsCssClass[name] = this.itemsCssClass[name].filter(item => item !== 'nica-disabled')

                let index = this.tabIndexByDataField.findIndex(r => r.dataField == name)
                this.tabIndexByDataField[index]['tabIndex'] = index;
                // carmine ho aggiunto questo if in quanto elemenRef di qualche campo era UNDEFINED
                if (this.elementRef[name])
                  this.elementRef[name].editorComponent.isDisabled = false
              }
            }

            control.enable();
          }


          break;
        case 'enabled':
          control.enable();

          break;
        case 'setValidators':
          const validators: ValidatorFn[] = [];

          if (Array.isArray(value)) {
            value.forEach(rule => {
              if (rule.type === 'required') {
                validators.push(Validators.required);
              }
              // Aggiungi altri tipi di validazione come necessario
            });
          }

          this.validationObject = {
            ...this.validationObject,
            [name]: {
              type: value[0].type,
              message: value[0].message

            }
          }

          this.validationClass[name] = false; //era true true

          control.setValidators(validators);
          //control.updateValueAndValidity();
          break;
        case 'validationRules': //! ------------ da testare
          let validationRules: ValidatorFn[] = [];

          if (Array.isArray(value)) {
            validationRules = this.addValidator(value, name)
          }

          if (value === null) {
            this.validationClass[name] = false
            control.setValidators([]);
            control.clearValidators();
            control.updateValueAndValidity();
            return
          }

          control.setValidators(validationRules);
          control.updateValueAndValidity();

          this.validationObject = {
            ...this.validationObject,
            [name]: {
              type: value[0].type,
              message: value[0].message

            }
          }

          this.validationClass[name] = false; //era true

          break;
        case 'cssClass':

          if (value == 'd-none') {
            if (this.itemsCssClass[name]) {
              this.itemsCssClass[name].push('d-none');
            }
            if (this.groupCssClass[name]) {
              if (typeof this.groupCssClass[name] != 'undefined') {
                let index = this.groupCssClass[name].indexOf('d-none'); // Trova l'indice dell'elemento 'readonly'
                if (index !== -1) {
                  this.groupCssClass[name].splice(index, 1); // Rimuove 1 elemento a partire dall'indice trovato
                  return
                }
              }
              this.groupCssClass[name].push(value);
            }
            return
          }

          if (value) {
            this.addCssClass(control, value as string);

          }
          if (this.groupCssClass[name]) {
            this.groupCssClass[name].push(value);
          }





          break;
        case 'setLabel':
          this.setLabel(control, value);
          break;
        case 'visible':

          if (!value) {

            this.itemsCssClass[name].push('d-none')
            let index = this.tabIndexByDataField.findIndex(r => r.dataField == name)
            this.tabIndexByDataField[index]['tabIndex'] = -1;
          }
          if (value) {

            this.itemsCssClass[name] = this.itemsCssClass[name].filter(res => res != 'd-none')
            let index = this.tabIndexByDataField.findIndex(r => r.dataField == name)
            this.tabIndexByDataField[index]['tabIndex'] = index;
          }
          break;
        case 'placeholder':


          this.formDataService.forEach(rFormGroup => {
            rFormGroup.data.forEach(data => {
              if (data.dataField == name) {
                data[command] = value
              }

            })
          })



          break;
        case 'readonly':
          this.setReadonly(control, value);
          break;
        case 'setMinValue':

          this.elementRef[name].editorComponent.minValue = value;

          break
        default:
          this.setAttribute(control, command, value)
          break;

      }
    }
    // else {
    //   console.error(this.itemsCssClass)
    //   console.error(this.elementRef)
    //   console.error(control)
    //   console.error(`Il percorso ${path} non è valido.`);
    // }
    ////console.log(name, this.itemsCssClass[name])

    return control

  }


  //Ottiene la lista dei componenti presenti nella form o un sigolo componente
  public getInputsComponents(nameRif?) {
    if (nameRif) {
      return this.elementRef[nameRif]
    }
    return this.elementRef
  }

  private addCssClass(control, className: string,) {
    const element = this.getElementByControl(control);
    if (element) {
      let name = this.getFormGroupName(control);
      this.itemsCssClass[name].push(className)
      element.classList.add(className);
    }
  }

  private removeCssClass(control: AbstractControl, className: string) {
    const element = this.getElementByControl(control);
    if (element) {
      element.classList.remove(className);
    }
  }

  private getElementByControl(control: AbstractControl): HTMLElement | null {
    const formGroupName = this.getFormGroupName(control);

    if (formGroupName) {
      const element = document.querySelector(`[name="${formGroupName}"]`);
      return element as HTMLElement;
    }

    return null;
  }

  private getFormGroupName(control: AbstractControl): string | null {
    // Verifica se il controllo è contenuto in un FormGroup
    const parent = control.parent;

    if (parent instanceof FormGroup) {
      // Ottieni il nome del controllo all'interno del FormGroup
      const formGroupName = Object.keys(parent.controls).find(name => parent.controls[name] === control);

      return formGroupName || null;
    }

    return null;
  }

  editorOption(editor, dataField, comando, valore) {

    let htmlElement = editor.htmlElement;


    switch (comando) {
      case 'disabled':
        htmlElement.disabled = valore;
        //////console.log('editorOption-->' + dataField, editor)
        if (valore) {
          this.itemsCssClass[dataField].push('disabled');
          let index = this.tabIndexByDataField.findIndex(ro => ro.dataField == dataField)
          this.tabIndexByDataField[index]['tabIndex'] = -1;
          if (typeof editor.component.buttonOption != 'undefined') {
            editor.component.buttonOption[0].disabled = valore
          }
        } else {
          let editoritem = editor.component.cssClass
          if (editoritem.indexOf('disabled') !== -1) {
            const indexOF = editoritem.indexOf('disabled');
            this.itemsCssClass[dataField].splice(indexOF, 1);

            if (typeof editor.component.buttonOption != 'undefined') {
              editor.component.buttonOption[0].disabled = valore
            }
            return;
          }


        }

        break;
      case 'visible':
        htmlElement.visible = valore;

        if (!valore)
          this.itemsCssClass[dataField].push("d-none");

        break;
      case 'cssClass':

        this.itemsCssClass[dataField].push(valore)
        break;

      case 'readOnly':
        htmlElement.readOnly = valore
        if (valore) {
          this.itemsCssClass[dataField].push("readonly")
        } else {
          let index = this.itemsCssClass[dataField].indexOf('readonly'); // Trova l'indice dell'elemento 'readonly'
          if (index !== -1) {
            this.itemsCssClass[dataField].splice(index, 1); // Rimuove 1 elemento a partire dall'indice trovato
          }
          this.itemsCssClass[dataField].fi
        }
        break;
      default:
        break;
    }


  }


  getEditor(dataf) {
    let element = this.elementRef[dataf].htmlElement
    return {
      option(d, f) {
        if (typeof f == 'boolean') {
          if (d == 'disabled') {
            if (f === true) {
              this.itemsCssClass[dataf].push('nica-disabled')
            }

            if (f === false) {
              let index = this.itemsCssClass[dataf].findIndex(r => r == 'nica-disabled')

              if (index >= 0) {

                this.itemsCssClass[dataf].splice(index, 1)

              }
            }
          }

        }
        element[d] = f
      },

      focus() {
        element.focus()
      }
    }
  }

  public addClassToElement(element, className) {
    if (typeof this.itemsCssClass[element] != 'undefined') {
      this.itemsCssClass[element].push(className)
    }
  }

  public removeClassToElement(element: any, className: any) {
    if (typeof this.itemsCssClass[element] != 'undefined') {
      let index = this.itemsCssClass[element].indexOf(className); // Trova l'indice dell'elemento 'readonly'
      if (index !== -1) {
        this.itemsCssClass[element].splice(index, 1); // Rimuove 1 elemento a partire dall'indice trovato
      }
    }
  }

  public removeClassToGroup(groupName: any, className: any) {
    if (typeof this.groupCssClass[groupName] != 'undefined') {
      let index = this.groupCssClass[groupName].indexOf(className); // Trova l'indice dell'elemento 'readonly'
      if (index !== -1) {
        this.groupCssClass[groupName].splice(index, 1); // Rimuove 1 elemento a partire dall'indice trovato
      }
    }
  }

  private setLabel(control: AbstractControl, label: string) {
    const controlName = this.getFormGroupName(control);

    if (controlName) {
      // Trova l'elemento del label tramite il selettore `[for="controlName"]`
      const labelElement = document.querySelector(`[for="${controlName}"] span`);

      if (labelElement) {
        labelElement.innerHTML = '' + label + '';
      }
    }
  }

  private getLabel(control: AbstractControl) {
    const controlName = this.getFormGroupName(control);

    if (controlName) {
      // Trova l'elemento del label tramite il selettore `[for="controlName"]`
      const labelElement = document.querySelector(`[for="${controlName}"]`);

      if (labelElement) {
        return labelElement.textContent;
      }
    }
  }

  private setAttribute(control: AbstractControl, attribute: string, value) {
    const controlName = this.getFormGroupName(control);

    if (controlName) {
      // Trova l'elemento del campo di input tramite il selettore `[name="controlName"]` se non ha name sei fottuto
      const inputElement = document.querySelector(`[name="${controlName}"]`);

      if (inputElement) {
        inputElement.setAttribute(attribute, value);
      }
    }
  }

  private setReadonly(control: AbstractControl, readonly: boolean) {
    const controlName = this.getFormGroupName(control);
    if (controlName) {
      // Trova l'elemento del campo di input tramite il selettore `[name="controlName"]` se non ha name sei fottuto
      const inputElement = document.querySelector(`[name="${controlName}"]`);

      if (inputElement) {
        if (readonly) {
          inputElement.setAttribute('readonly', 'readonly');
        } else {
          inputElement.removeAttribute('readonly');
        }
        //inputElement.setAttribute(attribute, value);
      }
    }

  }

  /***Fine Modfica degli elementi della form***/

  /**Funzioni della form**/

  async beforeSave() {





    let validate = await this.validate()
    if (!validate.isValid) {
      this.loader.hide()
      return
    }


    this.loader.show()
    let form = this;
    let dataEditForm = this.dataSet;

    let $event = {
      name: 'beforSave',
      formData: dataEditForm,
      masterComponent: form,
      isValid: this.dynamicForm.valid,
      cancella: false,
      resultSubject: new Subject<boolean>()

    }

    this.emittendButtonPush.emit($event)
    /* this.emittedAllEvent.emit($event) */

    const canProceed = await $event.resultSubject.pipe(
      timeout(this.timerCheck),
      catchError(() => of(true))
    ).toPromise();

    if (!canProceed) {
      this.loader.hide()
      return;
    }

    if (typeof $event.cancella != 'undefined') {
      if ($event.cancella) {
        this.loader.hide()
        return
      }
    }
    if (this.remoteOperation) {

      this.onFormSubmit();
      this.loader.hide()
      return;

    } else {

      let dataEditForm = this.dataSet;

      let data = {
        name: 'submitFormStatic',
        submitType: this.formActionType,
        data: dataEditForm,
        oDataFilter: await this.generaOdata(),
        masterComponent: this,
      }

      this.emittendButtonPush.emit(data)
      // this.emittedAllEvent.emit(data)
      this.loader.hide()
    }

    return
  }

  checkReturn() {

    let $event = {
      name: null,
      data: null
    }
    if (!this.remoteOperation) {
      $event.name = 'return';
      let form = this.formEdit;
      $event.data = this.formData;
      this.emittendButtonPush.emit($event)
      this.emittedAllEvent.emit($event)
      return;
    }
    if (Object.keys(this.allDataChanged).length > 0 && this.isCheckChange === true) {
      confirm("Desideri salvare le modifiche? ", "Attenzione!").then(val => {

        if (val) {
          let validate = this.validate()
          if (!validate.isValid) {
            this.loader.hide()
            return
          }
          this.onFormSubmit()

          $event.name = 'return'
          this.emittendButtonPush.emit($event)
          this.emittedAllEvent.emit($event)

        } else {
          $event.name = 'return';
          let form = this.formEdit;
          $event.data = this.formData;
          this.emittendButtonPush.emit($event)
          this.emittedAllEvent.emit($event)
        }

      })

    } else {

      $event.name = 'return'
      let form = this.formEdit;
      $event.data = this.formData;
      this.emittendButtonPush.emit($event)
      this.emittedAllEvent.emit($event)
    }
  }

  formRefreshInputData(key, value) {
    //this.dataJson[key]=value;    
    this.dataSetCopy[key] = value;
    this.dataSet[key] = value;
    this.showButtonTrash = [false];

    this.cdRef.detectChanges()
  }

  formRefreshGridDataSource() {
    // alert("wwwwwwwwwwwwwwwwwwwww","wwwwwwwwwwwww")
    // console.log(this.dynamicCustomComponentContainer)

    this.dynamicCustomComponentContainer.forEach(container =>
      console.log("ecco container ", container)
    );

    if (this.dynamicCustomComponentMap) {
      // Iteriamo su tutti i contenitori registrati in componentsMap
      this.dynamicCustomComponentMap.forEach((components) => {
        // console.log("cicciooooooooo ",components)
        components.forEach(comp => {
          if (comp.instance instanceof NicaAnagraficaComponent) {
            comp.instance.refresh();
          }
          //comp.destroy()
        });
      });
      // Svuotiamo la mappa
      // this.dynamicCustomComponentMap.clear();
    }



    //dynamicCustomComponentContainer
    this.dataGridForm.forEach(res => {
      //res.rowIsDisable=[false]
      // res.movimentiSelected = [false]
      //component.refresh()
      const campoGriglia = this.dataGridItems[res.idTable]['formGrid'];
      for (let instanceKey in campoGriglia) {
        res[instanceKey] = campoGriglia[instanceKey]
      }

      res.refresh()
    })
  }
  formGridDataSourceUpload(data, id) {

    this.dataGridForm.filter((item) => item.idTable === id).forEach((res: NicaDataGridComponent) => {
      res.dataSource = data
      res.textEmpty = data
      res.dataSourceMessage = res.textEmpty

      res.dataSourceTemp = JSON.parse(JSON.stringify(data));
      res.showNullData = false;
      res.textEmpty = '...Caricato'
      res.renderGrid().then(() => {
        this.cdRef.detectChanges()
      })
    })
  }

  formResetSelectionRows() {

    this.dataGridForm.forEach(res => {
      res.rowSelectedAll = false
      res.rowSelected = [false]
    })
  }

  formResetDisabledRows() {

    this.dataGridForm.forEach(res => {
      res.rowIsDisable = []

    })
  }

  formResetRowCustomClass() {

    this.dataGridForm.forEach(res => {
      res.rowcustomclass = []

    })
  }

  /*Salvataggio*/

  public onFormSubmit(event?) {

    let form = this;
    let dataEditForm = this.dataSet

    // if('percAss' in dataEditForm || 'percLic' in dataEditForm){
    //   dataEditForm = {...dataEditForm, id: this.selectedRows}
    // }

    if (this.formActionType == 'edit') {
      ////////////////console.log('edit');

      this.anagraficaService.actionPut(this.api, dataEditForm, true, this.api_rest, this.masterKey).then(result => {

        //da testare
        Object.assign(this.dataSet, result)

        if (this.showNotifyAfterSave) {

          notify({
            message: 'Anagrafica salvata',
            height: 45,
            width: 250,
            position: 'center center'

          }, 'success', 3000);

        }


        //Dopo salvataggio, invia i dati all'esterno per un refresh o altro...

        let eventName = 'submittedEditOk';

        let submitEmitEvent = {
          name: eventName,
          formData: this.dataSet,
          masterComponent: this
        }

        this.emittendButtonPush.emit(submitEmitEvent)
        this.emittedAllEvent.emit(submitEmitEvent)

        //this.formRefresh(this.queryString)
      });

    } else {

      delete dataEditForm['id']
      let check = this.IsJsonString(dataEditForm)
      let jsonData;

      if (!check) {
        jsonData = { ...dataEditForm };
      } else {
        jsonData = dataEditForm;
      }

      this.anagraficaService.actionInsert(this.api, jsonData, this.api_rest).then(result => {



        if (result['codeMessage'] == -1) {

          notify({
            message: result['descrMessage'],
            //message: 'Anagrafica salvata',
            height: 45,
            width: 250,
            position: 'center center'
          }, 'error', 3000);

          return false;
        } else {
          if (this.showNotifyAfterSave) {
            notify({
              message: 'Anagrafica salvata',
              height: 45,
              width: 250,
              position: 'center center'
            }, 'success', 3000);

          }

          //da testare
          Object.assign(this.dataSet, result)

          //Dopo salvataggio, invia i dati all'esterno per un refresh o altro...



          let eventName = 'submittedInsertOk';

          // this.dataSet['eventName'] = eventName;
          // this.dataSet['nameService'] = this.service

          let submitEmitEvent = {
            name: eventName,
            formData: this.dataSet,
            nameService: this.service,
            masterComponent: this
          }

          this.emittendButtonPush.emit(submitEmitEvent)
          this.emittedAllEvent.emit(submitEmitEvent)
        }

      });

    }






  }

  IsJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  /*Fine Salvataggio*/

  /*Inizio Validazion*/
  // async trimRecursive(input) {
  //   // Gestione base dei tipi primitivi
  //   if (typeof input === "string") {
  //     return input.trim();
  //   }

  //   if (Array.isArray(input)) {
  //     return input.map((item) => this.trimRecursive(item));
  //   }

  //   if (input !== null && typeof input === "object") {
  //     const result = {};
  //     for (const [key, value] of Object.entries(input)) {
  //       // Saltiamo chiavi o valori undefined/null
  //       if (key != null && value !== undefined) {
  //         result[key] = this.trimRecursive(value);
  //       }
  //     }
  //     return result;
  //   }

  //   // Ritorniamo gli altri tipi (number, boolean, null, undefined, function, etc.)
  //   return input;
  // }

  async PulisciJson(obj: any): Promise<any> {
    if (!obj || typeof obj !== 'object') return {};
    const cleaned: any = {};
    for (const key in obj) {
      if (!key || key.trim() === '' || key === 'undefined') continue;
      const value = obj[key];
      if (typeof value === 'string') {
        cleaned[key] = value.trim();
      } else if (value !== undefined) {
        cleaned[key] = value;
      }
    }
    return cleaned;
  }

  validate() {


    if (!this.dynamicForm.valid) {
      const campiObbligatoriMancanti = this.controllers(this.dynamicForm);

      if (campiObbligatoriMancanti.length == 0) {
        let validation = {
          isValid: true
        }

        return validation;
      }
      let msgHtml = ''
      campiObbligatoriMancanti.forEach(mess => {
        msgHtml += '<p>' + mess + '</p>'
      })
      let msg = campiObbligatoriMancanti.join('-')
      if (msgHtml > '')
        alert(msgHtml, 'Attenzione!')
    } else {
      if (this.dataSet)
        this.PulisciJson(this.dataSet).then(value => {
          this.dataSet = value;
        });
    }
    let valid = this.dynamicForm.valid
    this.dataGridForm.forEach(res => {
      let inEditorMode = res.inEditState
      if (inEditorMode) {
        valid = false;
        alert('Stai ancora modificando la griglia, ci sono dati da confermare', 'Attenzione')


        let rows = res.righe.map(row => {
          let ro = row.nativeElement

          if (ro.classList.contains('error-row')) {
            ro.classList.remove('error-row')
          }

          return ro;
        })
        res.editorData.forEach((editors, x) => {
          if (editors.edit)
            rows[editors.rowIndex].classList.add('error-row')
        })
      }
    })
    let validation = {
      isValid: valid
    }

    return validation;
  }

  controllers(formGroup: FormGroup | FormArray): string[] {
    let campiObbligatoriMancanti: string[] = [];
    const allKeys = Object.keys(this.validationObject);

    // Mappa di chiavi originali con versioni lowercase per confronto
    const originalKeyMap = new Map<string, string>();
    allKeys.forEach(key => originalKeyMap.set(key.toLowerCase(), key));

    // Trova le chiavi base da rimuovere (case insensitive, ma mappate correttamente)
    const keysToRemove = new Set<string>();
    for (const key of allKeys) {
      const underscoreIndex = key.indexOf('_');
      if (underscoreIndex !== -1) {
        const suffix = key.substring(underscoreIndex + 1).toLowerCase();
        if (originalKeyMap.has(suffix)) {
          keysToRemove.add(originalKeyMap.get(suffix)!);
        }
      }
    }
    // Costruisci il nuovo oggetto senza le chiavi base
    const cleanedSchema: Record<string, any[]> = {};
    for (const key of allKeys) {
      if (!keysToRemove.has(key)) {
        cleanedSchema[key] = this.validationObject[key];
      }
    }

    Object.keys(formGroup.controls).forEach(campo => {
      const control = formGroup.get(campo) as FormGroup
      //console.log(control)
      if (control.controls) {
        Object.keys(control.controls).forEach((keyErrori) => {
          //console.log(control.controls[keyErrori])
          //console.log(keyErrori)
          const formControl = control.controls[keyErrori] as FormControl

          if (formControl.errors !== null) {
            Object.keys(formControl.errors).forEach((key) => {
              if (cleanedSchema[keyErrori]) {
                if (Array.isArray(cleanedSchema[keyErrori])) {
                  cleanedSchema[keyErrori].map((objValidation) => {
                    if (objValidation.type == key) {
                      campiObbligatoriMancanti.push(objValidation.message);

                    }
                  })
                } else {
                  if (cleanedSchema[keyErrori]['type'] == key) {
                    campiObbligatoriMancanti.push(cleanedSchema[keyErrori]['message']);

                  }
                }
              }

            })
          }
        })
      }
    });
    return campiObbligatoriMancanti;
  }

  /*Fine Validazion*/

  openComponent(component, data) {

    let dataFilter
    let title = ''
    if (data.dynamic.costantValue) {

      const costantValue = data.dynamic.costantValue;
      let values
      costantValue.forEach(element => {
        let keyEle = element['key'];
        let val = ''
        if (typeof this.dataSet[element['value']] != 'undefined') {
          val = this.dataSet[element['value']]
        } else {
          val = element['value']
        }

        values = { ...values, [keyEle]: val }
      })
      dataFilter = JSON.stringify(values)

    }



    let campoDynamic = data.dynamic;



    title = campoDynamic.caption
    let showCaptionFooter = true;
    let showToolbarBottom = false
    let showCaptionHeader = true;

    let popupWidth = data.dynamic.popupWidth ? data.dynamic.popupWidth : 800;
    let popupHeight = data.dynamic.popupHeight ? data.dynamic.popupHeight : 600;


    if (campoDynamic.componentType != 'dynamicGrid') {
      showCaptionFooter = false;
      showToolbarBottom = true;
      showCaptionHeader = false;
      popupWidth = null
    }

    let queryString = ''
    if (typeof campoDynamic.queryString != 'undefined') {
      queryString = campoDynamic.queryString
    }


    const dataToSend = [{
      apiset: data.dynamic.dataSource,
      id: '',
      service: data.dynamic.service ? data.dynamic.service : null,
      InviaA: null,
      staticQueryFilter: data.dynamic.filterStatic,
      toolbarComponentFilter: null,
      filter: dataFilter,
      currentTabName: component,
      currentTabId: component,
      componentName: component

    }]

    let guid = Math.random().toString().replace("0.", "")

    this.userComponentService.setNewPopUp(guid, component, dataToSend, popupWidth, data, null, showCaptionFooter, showCaptionHeader, title);

    this.userComponentService.outputComponent.subscribe(currentOutput => {

      if (currentOutput.name == "onRowSelectionChange" && currentOutput.guid == guid) {

        const dataOutput = currentOutput
        const campo = currentOutput.accessoringData;
        let event = dataOutput;

        this.emittendButtonPush.emit(event);
        this.emittedAllEvent.emit(event)
        if (event.cancel) {
          return
        }

        this.updateFiedlFromGridSelection(dataOutput.data, campo, component);


      }

      //perchè uso nica anagrafica maaaa vedremo poi 
      if (currentOutput.name == "onSelectionChanged" && currentOutput.guid == guid) {

        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);
        this.emittedAllEvent.emit(event)
        if (event.cancel) {
          return
        }

        this.updateFiedlFromGridSelection(currentOutput.data, currentOutput.accessoringData, component);
        //alert("dddd","eeee")

      }

      if (currentOutput.name == "masterDetailSelection" && currentOutput.guid == guid) {
        this.updateFiedlFromGridSelection(currentOutput.data, currentOutput.accessoringData, component);

      }

      if (currentOutput.name == "onRowExpanding" && currentOutput.guid == guid) {
        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData

        let event = dataOutput;
        this.emittendButtonPush.emit(event);
        this.emittedAllEvent.emit(event)
      }

      if (currentOutput.name == "onInitilized" && currentOutput.guid == guid) {
        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);
        this.emittedAllEvent.emit(event)
      }

      if (currentOutput.name == "masterDetailInsert" && currentOutput.guid == guid) {

        /* 
          gestisco l'inserimento di un master detail di Nica anagrafica per poter personalizzare l'apertura e la chiusura del
          popUp dal componente Padre. In attesa di nuove idee o migliorie che mi verranno in mente più avanti
          
        */

        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);
        this.emittedAllEvent.emit(event)
      }

      if (currentOutput.name == "masterDetailEdit" && currentOutput.guid == guid) {

        /* 
          gestisco l'inserimento di un master detail di Nica anagrafica per poter personalizzare l'apertura e la chiusura del
          popUp dal componente Padre. In attesa di nuove idee o migliorie che mi verranno in mente più avanti
          
        */

        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);
        this.emittedAllEvent.emit(event)
      }
      if (currentOutput.name == "masterDetailInitilized" && currentOutput.guid == guid) {

        /* 
          gestisco l'inserimento di un master detail di Nica anagrafica per poter personalizzare l'apertura e la chiusura del
          popUp dal componente Padre. In attesa di nuove idee o migliorie che mi verranno in mente più avanti
          
        */

        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);
        this.emittedAllEvent.emit(event)
      }

      //Eventi da componenti
      if (currentOutput.name == 'submittedInsertOk' && currentOutput.guid == guid) {

        //currentOutput.cancellaRefresh = true;

        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;
        event.name = 'formFromComponentSaved';
        event.guid = currentOutput.guid;

        //this.emittedItemsEvet.emit(event);
        this.emittedAllEvent.emit(event)


      }



    })
  }

  updateFiedlFromGridSelection(data, item, component?, input?) {

    if (data) {

      let valueExpr = item.dynamic.valueExpr != '' ? item.dynamic.valueExpr : item.dynamic.displayExpr
      let displayExpr = item.dynamic.displayExpr
      let value
      if (Array.isArray(displayExpr)) {
        let val = []
        displayExpr.forEach(res => {
          if (data[res]) {
            let value1 = data[res]

            let dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
            let isMatch = dateType.test(value1);

            if (isMatch) {

              value1 = this.formatDate(value1, 'it')
            }

            val.push(value1)
          }

        })
        value = val.join(' - ');
      } else {
        if (data[valueExpr]) {
          let value2 = data[valueExpr]
          value = value2;
        } else {
          alert(valueExpr + ' è nullo', 'Errore!');
        }

      }

      if (!value) {
        //alert('Nessun dato da selezionare manca:' + valueExpr, 'Attenzione!')
        return
      }


      let key = item.dataField;

      /***Se ci sono campi relazionari***/

      let related = item.dynamic.related

      /***************************************/
      const keyVariable = key;
      const valueArray = value;

      this.dataSet[key] = value;



      if (related) {

        let newItem;
        let newItemDesc;
        related.forEach((values, key) => {
          let arrayValue = values.split('|')
          if (arrayValue.length > 1) {

            this.dataSet[arrayValue[1]] = data[arrayValue[0]]
          } else {

            this.dataSet[values] = data[values]
          }


        })

      }

      if (component) {


        this.userComponentService.destroyOutputComponent()
        this.userComponentService.destroyCurrentOpenPopUp(component);


      }

    }
  }

  // Funzione di utilità per formattare le date
  private formatDate(dateString: string, type = 'EN'): string {
    // Supponiamo che la data in ingresso sia una stringa nel formato 'yyyy-MM-dd'
    const date = new Date(dateString);

    // Formatta la data come necessario
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Mese è 0-based
    const day = date.getDate().toString().padStart(2, '0');
    if (type == 'EN') {
      return `${year}-${month}-${day}`;
    }

    if (type == 'it') {
      return `${day}-${month}-${year} `;
    }
  }

  /**Fine funzioni della form**/

  /**funzioni della griglia nella form**/

  highlightAndFocusGriglia(events, dataField: string) {

    // Impedisce al comportamento predefinito del tasto "Tab" di avvenire
    event.preventDefault();

    // Trova l'elemento campo Griglia per ID
    event.preventDefault();
    const campoGrigliaComponent = document.getElementById(dataField);
    //console.log('campoGrigliaComponent-->', campoGrigliaComponent)
    this.itemsCssClass[dataField].push('state-active')
    if (campoGrigliaComponent && typeof (campoGrigliaComponent as any).selectContent === "function") {
      (campoGrigliaComponent as any).selectContent(); // Chiamata al metodo selectContent() del componente
    }

    this.dataGridForm.forEach(res => {
      if (res.idTable == dataField) {
        res.selectContent()
      }
    })
  }

  lostFocusGriglia(event, dataField: string) {
    this.itemsCssClass[dataField] = []
  }

  formDataGridEvent(event, campo?, isRemote?) {
    /* if(!isRemote){  
      event.component.dataSource = this.dataSet[campo.dataField]
    } */
    //console.log('formDataGridEvent--->',event)
    if (event.name == 'dataSourceChange') {
      let dataField = campo.dataField
      this.dataSet[dataField] = event.data
    }
    this.outputDataGridEvent(event);

  }


  public async generaOdata(filtered?: string) {
    /*
    contains(Name, 'phone')
    substringof('ignazio',tolower(descrizioneScheda))
    contains(tolower(descrizione),'pippo')
examplefilter:'
        [
          ["descrizioneScheda", "contains", "{{descrizioneScheda}}"],
          "and",
          [
              ["idTipoRaee", "=", "{{idTipoRaee}}"],
            "or",
            ["idTipoRaee", "=", "{{idTipoRaee}}""]
          ]
          "and"
          ["quantitaPrevista", ">", {{quantitaPrevista}}],
        ]
    '


    */
    let formData = []
    let i = -1, idx = 0
    let filterOdataWrapper = []
    let filterOdata
    formData = this.formDataService.filter(r => r.itemType == 'group');
    let that = this;
    let newData: any[] = [];
    filterOdataWrapper[0] = []
    i = 0;
    let fieldTypes = [];
    let newVal = null;
    let newOdataFilter = null;

    if (typeof filtered === "string" && typeof filtered !== undefined && filtered !== null && filtered.length > 0) {
      // filtro in string
      //console.log(this.dataFields['descrizioneScheda'])
      var variable = filtered.match(/{{[\w\d]+}}/g);
      for (let r = 0; r < variable.length; r++) {
        let v = variable[r].replace('}}', '');
        v = v.replace('{{', '');
        //aggiungere il controllo su newData
        filtered = filtered.replace(variable[r], this.formEdit.formData[v])
        let cField = {
          [this.dataFields[v]]: this.dataFields[v].odataType,
        }
        fieldTypes.push(cField)
      }
      //--------------------------       
      filterOdataWrapper = eval(filtered);

    } else {
      formData.forEach(gruppo => {
        //let logicalOperator = gruppo.logicalOperator
        //filterOdataWrapper.push(logicalOperator)  
        //i=filterOdataWrapper.length;
        //filterOdataWrapper[i]=[]
        //i++;
        //filterOdataWrapper[i]=[]
        //type: "campoHidden"
        let itemsOdata = gruppo.data.filter(r => r.odataType && r.type != 'campoHidden');
        itemsOdata.forEach(dataR => {
          let currentDataField;
          let DataFieldForOdata;
          currentDataField = (dataR.staticDataField) ? dataR.staticDataField : dataR.dataField
          //currentDataField=dataR.dataField
          DataFieldForOdata = (dataR.staticDataField) ? dataR.staticDataField : dataR.dataField

          //let calcola=(dataR.staticDataField && dataR.staticDataField!=dataR.dataField)
          if (dataR.odataFilter > "" && that.dataSet[currentDataField]) {
            // && that.dataSet[currentDataField].length>0)             
            newOdataFilter = dataR.odataFilter
            filterOdataWrapper[i][idx] = []
            filterOdataWrapper[i][idx][0] = [] //prima lo zeronon c'era
            if (dataR.odataType == 'select') {
              // da vedereeeeeeeeeeeeeeeeeeeeeeeeeee
              filterOdataWrapper[i][idx][0].push(DataFieldForOdata)
              filterOdataWrapper[i][idx][0].push("=")
              if (!Array.isArray(that.dataSet[currentDataField]))
                //filterOdataWrapper[i][idx][0].push(that.dataSet[currentDataField][0])
                filterOdataWrapper[i][idx][0].push(that.dataSet[currentDataField])
            } else {
              let vl = that.dataSet[dataR.dataField];
              newVal = that.dataSet[currentDataField];
              newOdataFilter = dataR.odataFilter;
              if (typeof vl == 'string') {
                //-----------------------------------------
                //let vl=that.dataSet[dataR.dataField];
                let first = vl.substring(0, 1)
                let last = vl.slice(-1);
                //newVal=that.dataSet[currentDataField];
                //newOdataFilter=dataR.odataFilter; 
                if (first == '%') {
                  newVal = vl.substring(1);
                  newOdataFilter = 'endswith';
                } else if (last == "%") {
                  newVal = vl.slice(0, -1);
                  newOdataFilter = 'startswith';
                }
                //-----------------------------------------
              }

              filterOdataWrapper[i][idx][0].push(DataFieldForOdata)
              filterOdataWrapper[i][idx][0].push(newOdataFilter)
            }
            if (dataR.odataType == 'date')
              //  filterOdataWrapper[i][idx][0].push("" + that.dataSet[dataR.dataField] + '')
              filterOdataWrapper[i][idx][0].push("!" + that.dataSet[dataR.dataField] + '!')
            else if (dataR.odataType == 'select') {
              if (Array.isArray(that.dataSet[currentDataField]))
                filterOdataWrapper[i][idx][0].push(that.dataSet[currentDataField][0])
              else
                filterOdataWrapper[i][idx][0].push(that.dataSet[currentDataField])
              let rt = 1;
              console.log("sono in select ", dataR)
              for (let ii = 1; ii < that.dataSet[currentDataField].length; ii++) {
                if (ii > 0) filterOdataWrapper[i][idx][rt] = "or";//.push("or")
                filterOdataWrapper[i][idx][rt + 1] = []
                filterOdataWrapper[i][idx][rt + 1].push(DataFieldForOdata)
                filterOdataWrapper[i][idx][rt + 1].push("=")
                filterOdataWrapper[i][idx][rt + 1].push(that.dataSet[currentDataField][ii])
                rt += 2;
              }
            } else {
              if (newVal)
                filterOdataWrapper[i][idx][0].push(newVal)
              else
                filterOdataWrapper[i][idx][0].push(that.dataSet[dataR.dataField])

            }
            //filterOdataWrapper[i][idx][0].push(that.formEdit.formData[dataR.dataField])





            let cField = {
              [dataR.dataField]: newOdataFilter,
            }
            fieldTypes.push(cField)

            i++;
            filterOdataWrapper[i] = 'and';
            i++;
            filterOdataWrapper[i] = []
          }
        })
      })
      // if(filterOdataWrapper.length==0) return '';
      filterOdataWrapper.splice(-2)
    }
    //-----------------------------
    if (filterOdataWrapper.length == 0 || fieldTypes.length == 0) return '';

    let dataSource = new DataSource({
      store: new ODataStore({
        fieldTypes: fieldTypes,
        version: 4,
        url: "https://js.devexpress.com/Demos/DevAV/odata/Products",
      }),

      /*select: [
          'Product_ID',
          'Product_Name',
          'Product_Cost',
          'Product_Sale_Price',
          'Product_Retail_Price',
          'Product_Current_Inventory'
      ]*/
    });

    const store = new ODataStore({
      fieldTypes: fieldTypes,
      version: 4,
      url: "",
      beforeSend: function (e) {
        let regex = /'!/gi;
        filterOdata = e.params.$filter.replaceAll(regex, '');
        regex = /!'/gi;
        filterOdata = filterOdata.replaceAll(regex, '');
        regex = /T00:00:00/gi;
        filterOdata = filterOdata.replaceAll(regex, '');


        //cicciobello=e.params.$filter.replaceAll("'!", '');
        //cicciobello=cicciobello.replaceAll("!'", '').then(result=>{
        //cicciobello=e.params.$filter.replaceAll("'!", '');

        //cicciobello=e.params.$filter
        // return e.params.$filter;
        //throw "Error 42";
        //return e.params.$filter;
      }
    });

    let pippo = await store.load({ filter: filterOdataWrapper });



    filterOdata = filterOdata.replaceAll('substringof', 'contains')
    /*let variables = cicciobello.match(/substringof\(([^)]+)\)/g);
    for(let ii=0;ii<variables.length;ii++){
      let result=variables[ii].replace('substringof','contains');
      cicciobello=cicciobello.replace(variables[ii],result) 
    }           
    console.log(variables)*/
    let Pezzotto = filterOdata.split("and")
    console.log("Pezzotto ", Pezzotto)
    let RispostaOdata = [];
    for (let x in Pezzotto) {
      if (Pezzotto[x].indexOf('undefined') == -1) {
        RispostaOdata.push(Pezzotto[x])
      }
    }
    if (RispostaOdata.length > 0)
      return RispostaOdata.join("and")
    else return "";

    //return filterOdata


    //------------------------------
    // return filterOdataWrapper
  }

  public forceSaveSession() {
    if (typeof this.nameSessionStorage != 'undefined') {
      delete this.dataSet[""];
      sessionStorage.setItem(this.nameSessionStorage, JSON.stringify(this.dataSet))
    }
  }

  createODataFilterList(field: string, values: any[]): any {
    return [field, 'in', values];
  }

  formDataGridEventToolbar(event) {
    this.outputDataGridEvent(event)
  }
  /**Fine funzioni della griglia nella form**/

  /***************************** FUNZONI DALLA FORM TABBED ALLA FORM MASTER **************************************** */
  outDatiSubForm(event) {
    //console.log('SSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS', event)
    //! passo i dati della form tabbed alla form master
    /* if (event.newDataSetSubForm) {
      Object.assign(this.dataSet, event.newDataSetSubForm)
      this.allDataChanged[event.dataFieldForm] = event.newSet
    } */
    if (event.newSet && event.dataFieldForm && event.masterKey) {
      Object.assign(this.dataSet[event.dataFieldForm], event.newSet)
      /* if(isArray(this.dataSet[event.dataFieldForm])){
        this.dataSet[event.dataFieldForm].forEach(dato => {
          if(dato)
        });
      } */
      Object.assign((this.allDataChanged[event.dataFieldForm], event.newSet))
    }
    this.emittedAllEvent.emit(event)
    this.cdRef.detectChanges()
  }

  /***************************** FUNZONI DEL DYNAMIC CUSTOM COMPONENT **************************************** */
  aggiungiDynamicComponent(containerId: string, componentName: string, componentId: string, data?: any) {
    //trova il contenitore
    const container = this.getContainerById(containerId);
    if (!container) {
      console.error(`Container con ID ${containerId} non trovato.`);
      return;
    }
    // Creare il componente dinamico
    const factories = Array.from(this.componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === componentName);
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(factoryClass);
    const componentRef = container.createComponent(componentFactory);
    const createdNativeElement = container.element.nativeElement;
    createdNativeElement.appendChild(componentRef.location.nativeElement);
    // Impostiamo l'ID direttamente sull'elemento appena creato
    componentRef.location.nativeElement.setAttribute('id', componentId);
    //passa i dati
    if (data) {
      Object.assign(componentRef.instance, data);
    }
    // Memorizziamo i componenti caricati nel container nella mappa
    if (!this.dynamicCustomComponentMap.has(containerId)) {
      this.dynamicCustomComponentMap.set(containerId, []);
    }
    this.dynamicCustomComponentMap.get(containerId)!.push(componentRef);
    // Intercetta e sottoscrive TUTTI gli EventEmitter automaticamente
    Object.keys(componentRef.instance).forEach(property => {
      const propertyValue = (componentRef.instance as any)[property];
      if (propertyValue instanceof EventEmitter) {
        propertyValue.pipe(takeUntil(this.$distruggi)).subscribe((eventData: any) => {
          //console.log(eventData)
          let evento = eventData
          if (typeof eventData === 'object') {
            evento['dynamicComponent'] = componentName || ''
            evento['masterkeyForm'] = this.masterKey
          } else {
            evento = {
              event: eventData,
              masterkeyForm: this.masterKey,
              dynamicComponent: componentName || '',
              ...eventData
            }
          }

          /* if(componentName==="NicaAnagraficaComponent"){
            if(eventData.name==="onSaving"){
              if(eventData.changes&&eventData.changes[0].type==="insert"){
                eventData.changes[0].data
                this.dataSet['']
          
              }
            }
          } */

          if (eventData.name && eventData.name === "submitFormStatic") {
            if (evento.newSet) {
              if (this.dataSetCopy[data.dataFieldToSend] && this.dataSetCopy[data.dataFieldToSend] !== null) {
                this.dataSet = Object.assign(this.dataSetCopy[data.dataFieldToSend], evento.newSet)
                this.allDataChanged[data.dataFieldToSend] = evento.newSet
              } else {
                this.dataSet[data.dataFieldToSend] = evento.newSet
                this.allDataChanged[data.dataFieldToSend] = evento.newSet
              }
            }
            /* this.dataSetCopy = Object.assign(this.dataSet[data.dataFieldToSend], evento.newSet) */
          }
          this.emittedAllEvent.emit(evento)
          //console.log(evento)
        });
      }
    });
    return
  }
  //processa i dati da mandare al componente per avere dati dinamici modificare qui
  processaDataToSendDynamic(configuration: { [key: string]: any }) {
    let dataSend = {}
    let config = configuration
    //console.log(configuration)
    Object.keys(config).forEach((key) => {
      if (key === 'filterEditor') {
        if (config[key].includes('$')) {
          if (this.dataJson) {
            if (this.dataJson[config['masterKey']] != '' && typeof this.dataJson[config['masterKey']] != 'undefined') {
              config['queryString'] = config[key].replace('$', this.dataJson[config['masterKey']]);
            }
            config['queryString'] = this.processFiltro(config['queryString'], this.dataJson);
          } else {
            if (this.dataSet[config['masterKey']] != '' && typeof this.dataSet[config['masterKey']] != 'undefined') {
              config['queryString'] = config[key].replace('$', this.dataSet[config['masterKey']]);
            }
            config['queryString'] = this.processFiltro(config['queryString'], this.dataSet);
          }
        }
      }
      if (key === 'filter') {
        config['filter'] = this.processFiltro(config['filter'], this.dataJson);
      }
      if (key === 'costantValues' && config['costantValues']) {
        config['costantValues'].forEach((costante: costantValue) => {
          if (costante.key === 'UtenteCheInserisce') {
            costante.value = this.utenteService.InfoDatiUtenteConnesso.nomeCompleto || ''
          } else {
            if (this.dataJson) {
              if (this.dataJson[costante.key]) {
                costante.value = this.dataJson[costante.key]
              } else if (this.dataJson[costante.value]) {
                costante.value = this.dataJson[costante.value]
              }
            } else {
              if (this.dataSet[costante.key]) {
                costante.value = this.dataSet[costante.key]
              } else if (this.dataSet[costante.value]) {
                costante.value = this.dataSet[costante.value]
              }
            }
          }

        });
        //console.log('AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA', config['costantValues'])
      }
      if (config['static']) {
        if (key === 'dataSetKey' && config[key] !== '') {
          if (config['dataFieldToSend'] && config['dataFieldToSend'] !== '') {
            config[config[key]] = this.dataSet[config['dataFieldToSend']] || []
          }
        }
      } else {
        if (key === 'dataSetKey' && config[key] !== '') {
          config[config[key]] = this.dataSet || []
        }
      }
    })
    Object.assign(dataSend, config)
    Object.assign(dataSend, { dataFieldForm: config['dataFieldToSend'] || '' })
    Object.assign(dataSend, { isEdit: this.isEdit })
    Object.assign(dataSend, { dataJson: this.dataJson })
    console.log(dataSend)
    return dataSend
  }
  //processa il filtro tipo ?id=[id] in ?id=1 prendendo i valori da dataJson
  processFiltro(query, data) {
    return query.replace(/\[([^\]]+)\]/g, (match, variable) => {
      return data.hasOwnProperty(variable) ? data[variable] : match;
    });
  }
  apriDynamicPopupComponent(eventoBtn, campo) {
    //assegna al nome dell'evento il nome salvato nel template service per il bottone 
    eventoBtn.event = campo.button && campo.button.event ? campo.button.event : eventoBtn.event
    //console.log(campo)
    //console.log(eventoBtn)
    const campoComponent = campo.component
    const config = campoComponent.configuration
    if (campoComponent && campoComponent.nameComponent && campoComponent.nameComponent !== '') {
      //processa i dati da mandare
      const dataToSend = this.processaDataToSendDynamic(config)
      Object.assign(dataToSend, { dataJson: this.dataJson, dataSet: this.dataSet })
      let guid = Math.random().toString().replace("0.", "")

      this.userComponentService.setNewPopUp(guid, campoComponent.nameComponent, null, '800', null, dataToSend, false, true, '', 'top');
      this.userComponentService.outputComponent.pipe(takeUntil(this.$distruggi)).subscribe(res => {
        let evento = res
        if (typeof res === 'object') {
          evento['dynamicComponent'] = campoComponent.nameComponent || ''
        } else {
          evento = {
            event: res,
            dynamicComponent: campoComponent.nameComponent || ''
          }
        }
        //console.log(this.dynamicCustomComponentMap)
        this.emittedAllEvent.emit(evento)
        //console.log(evento)
        //console.log(res)
        //res.outputComponent = campoComponent.nameComponent
      })
    } else {
      console.error(`Errore nel dynamic popup ${campo.dataField}`)
    }
    return;
  }
  //cancella tutti componenti dinamici creati svuotando la mappa e i container
  clearTuttiDynamicComponent() {
    if (this.dynamicCustomComponentMap) {
      // Iteriamo su tutti i contenitori registrati in componentsMap
      this.dynamicCustomComponentMap.forEach((components) => {
        // Distruggiamo ogni componente
        components.forEach(comp => comp.destroy());
      });
      // Svuotiamo la mappa
      this.dynamicCustomComponentMap.clear();
    }
    if (this.dynamicCustomComponentContainer) {
      // Puliamo anche i contenitori ViewContainerRef
      this.dynamicCustomComponentContainer.forEach(container => container.clear());
    }
    return;
  }
  //cancella i componenti dinamici creati nel container
  clearDynamicComponentContainer(containerId: string) {
    const components = this.dynamicCustomComponentMap.get(containerId);
    if (components) {
      components.forEach(comp => comp.destroy()); // Distrugge tutti i componenti nel container
      this.dynamicCustomComponentMap.delete(containerId); // Rimuove il riferimento nella mappa
    }
    // Troviamo il ViewContainerRef associato e lo puliamo
    const container = this.getContainerById(containerId);
    if (container) {
      container.clear();
    }
    return
  }
  //cancella il componente creato nel container
  clearDynamicComponentId(containerId: string, componentId: string) {
    const components = this.dynamicCustomComponentMap.get(containerId); // Ottieni l'array completo
    if (!components || components.length === 0) {
      return;
    }
    // Trova l'indice del componente con l'ID specificato
    const index = components.findIndex(comp => comp.location.nativeElement.id === componentId.toString());
    if (index !== -1) {
      components[index].destroy(); // Distrugge il componente
      components.splice(index, 1); // Rimuove il riferimento dalla lista
      // Se il contenitore è ora vuoto, rimuoviamolo dalla mappa
      if (components.length === 0) {
        this.dynamicCustomComponentMap.delete(containerId);
      }
    }
    return
  }
  //ritorna il container con l'id associato
  getContainerById(containerId: string): ViewContainerRef | undefined {
    if (this.dynamicCustomComponentContainer) {
      // console.error(this.dynamicCustomComponentContainer)
      return this.dynamicCustomComponentContainer.find((container: any) => {
        //console.error(container)
        return container.element.nativeElement.id === containerId;
      });
    } else {
      return undefined
    }
  }
  /***************************** FINE FUNZONI DYNAMIC CUSTOM COMPONENT **************************************** */
}


